<template>
  <el-select
    style="width: 280px"
    filterable
    collapse-tags
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :multiple="multiple"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option
      v-for="item in optionList"
      :label="!showRegionId ? `${item.name}` : `${item.name}(${item.regionId})`"
      :value="item.regionId"
      :key="item.regionId"
    >
    </el-option>
  </el-select>
</template>

<script>
const businessLineMap = {
  1204: 1,
  1203: 2,
}
export default {
  name: 'filter-businessline-region',

  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    businessLine: [String, Number],
    showRegionId: {
      // label 是否展示regionId
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      optionList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  watch: {
    businessLine: {
      handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          this.selectedValue = this.multiple ? [] : ''
          this.optionList = []
        }
        this.getOptionList()
      },
      immediate: true,
    },
  },

  methods: {
    getOptionList() {
      if (this.optionList.length > 0 || !this.businessLine) return
      const params = {
        businessLine: businessLineMap[this.businessLine] || this.businessLine,
      }
      this.fetch
        .get('queryRegionByBusinessline', { params })
        .then((res) => {
          this.optionList = res.data || []
          if (this.required && this.optionList[0]) {
            this.selectedValue = this.multiple
              ? [this.optionList[0].regionId]
              : this.optionList[0].regionId
          }
        })
        .catch(() => {})
    },
  },
}
</script>
